import { analyticsPageLoad } from "../state/modules/analytics/actions";
import commonConfig from "../config/common";

const {
  globalKeys: { asosKey, plpKey, pageLoadDataKey, eventBusKey }
} = commonConfig;

const setupAdobe = ({ dispatch }) => {
  const eventBus = window[asosKey][eventBusKey];
  eventBus.addListener("analytics-ready", () => {
    const pageLoadData = window[asosKey][plpKey][pageLoadDataKey];
    delete window[asosKey][plpKey][pageLoadDataKey];
    dispatch(analyticsPageLoad(pageLoadData));
  });
};

export default setupAdobe;
